module.exports = __webpack_public_path__ + "static/media/work3.f1756ff5.webp";